<template>
  <section>
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex md12 class="top-breadcrumbs">
        <v-container grid-list-md>
          <v-layout>
          <v-breadcrumbs :items="breadcrumbs" divider=" / "></v-breadcrumbs>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout wrap pb-6 pt-6>
      <v-container grid-list-md>
        <v-layout wrap class="hidden-sm-and-down">
          <v-flex md12 lg12>
            <h3 class="h1">玛娅理念</h3>
            <p class="p1">玛娅人始终铭记企业使命和核心价值观，为实现企业愿景不懈奋进。</p>
          </v-flex>
          <v-flex xs12 sm12 md7 lg7 pr-md-6 mt-2>
              <v-img :src="img" aspect-ratio="1.4"></v-img>
          </v-flex>
          <v-flex xs12 sm12 md5 lg5 pl-md-6 mt-2 class="md-flex">
            <v-layout wrap>
              <v-flex class="ln-div ln-actived" data-index="1" xs12 sm12 md12 lg12 @mouseenter="actived">
                <h3 class="ln-h">使命</h3>
                <p class="ln-p">缔造品质空间&nbsp;&nbsp;&nbsp;&nbsp;创享爱的生活</p>
              </v-flex>
              <v-flex class="ln-div" data-index="2"  xs12 sm12 md12 lg12 @mouseenter="actived">
                <h3 class="ln-h">愿景</h3>
                <p class="ln-p">成为中国高端全屋家居行业的标杆</p>
              </v-flex>
              <v-flex class="ln-div" data-index="3"  xs12 sm12 md12 lg12 @mouseenter="actived">
                <h3 class="ln-h">核心价值观</h3>
                <p class="ln-p">客户第一&nbsp;&nbsp;&nbsp;&nbsp;高效执行&nbsp;&nbsp;&nbsp;&nbsp;卓越运营</p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap class="hidden-md-and-up">
          <v-flex xs12 sm12 mb-6>
            <h3 class="h1">玛娅理念</h3>
            <p class="p1">玛娅人始终铭记企业使命和核心价值观，为实现企业愿景不懈奋进。</p>
          </v-flex>
          <v-flex xs12 sm12 mb-6>
            <h3 class="ln-m-h">使命</h3>
            <p class="ln-m-p">缔造品质空间 创享爱的生活</p>
            <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/about-ln-1.png"></v-img>
          </v-flex>
          <v-flex xs12 sm12 mb-6>
            <h3 class="ln-m-h">愿景</h3>
            <p class="ln-m-p">成为中国高端全屋家居行业的标杆</p>
            <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/about-ln-2.png"></v-img>
          </v-flex>
          <v-flex xs12 sm12 mb-6>
            <h3 class="ln-m-h">核心价值观</h3>
            <p class="ln-m-p">客户第一 高效执行 卓越运营</p>
            <v-img src="https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/about-ln-3.png"></v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </section>
</template>
<script>
export default {
  data: () => ({
    img: 'https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/about-ln-1.png',
    breadcrumbs: []
  }),
  created () {
    this.breadcrumbs = [
      { text: '关于玛娅', disabled: true },
      { text: '玛娅理念', disabled: true }
    ]
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  methods: {
    actived (e) {
      document.querySelectorAll('.ln-div').forEach(function (el) {
        el.classList.remove('ln-actived')
      })
      e.target.classList.add('ln-actived')
      let index = e.target.dataset.index
      this.img = 'https://ctk-website.oss-cn-shanghai.aliyuncs.com/maier/about-ln-' + index + '.png'
    }
  }
}
</script>
<style lang="css">
  @import '../css/about.css';
</style>
